import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Card, CardHeader, CardBody } from 'reactstrap';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { getFiscalYearQuery } from '../../../slices/fiscalYear/thunk';
import PeriodList from './PeriodList';
import AddEditFiscalYearModal from './Add_Edit/AddEditFiscalYear';
import DeleteFiscalYearModal from './Delete/DeleteFiscalYear';
import { Link } from 'react-router-dom';

const FiscalYearList = () => {
	const dispatch = useDispatch();
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [data, setData] = useState({});

	// get fiscal year loading redux state'
	const fiscalYearSuccess = useSelector(state => state.FiscalYear.isSuccess);

	const columns = useMemo(
		() => [
			{
				header: 'Acciones',
				accessorKey: 'actions',
				enableSorting: false,
				enableColumnFilter: false,
				enableGlobalFilter: false,
				Cell: ({ row }) => (
					<React.Fragment>
						<div className='d-flex'>
							<div className='flex-shrink-0'>
								<ul className='list-inline mb-0'>
									<li className='list-inline-item'>
										<Link
											to='#'
											onClick={() => {
												setIsEdit(true);
												setData(row.original);
												setModal(true);
											}}
										>
											<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
										</Link>
									</li>
									<li className='list-inline-item'>
										<Link
											to='#'
											className='remove-item-btn'
											onClick={() => {
												setData(row.original);
												setModalDelete(true);
											}}
										>
											<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</React.Fragment>
				),
			},
			{
				header: 'Nombre',
				accessorKey: 'name',
				align: 'center',
			},
			{
				header: 'Descripción',
				accessorKey: 'description',
				align: 'center',
			},
			{
				header: 'Fecha de Inicio',
				accessorKey: 'start_date',
				dataType: 'date',
				align: 'center',
			},
			{
				header: 'Fecha de Fin',
				accessorKey: 'end_date',
				dataType: 'date',
				align: 'center',
			},
		],
		[]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setData({});
												setModal(true);
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Año Fiscal
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								getDataFunc={getFiscalYearQuery}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								baseFilters={{
									disable: {
										$eq: false,
									},
								}}
								nameFile={'años_fiscales'}
								masterDetailComponent={({ row }) => (
									<PeriodList fiscalYearId={row.original._id} />
								)}
								getRowIdTable={row => row._id}
								refetchRemoteData={fiscalYearSuccess}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setData({});
											setModal(true);
										},
										title: 'Crear Año Fiscal',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditFiscalYearModal
				isOpen={modal}
				toggle={() => setModal(!modal)}
				isEdit={isEdit}
				data={data}
			/>

			<DeleteFiscalYearModal
				isOpen={modalDelete}
				toggle={() => setModalDelete(!modalDelete)}
				data={data}
			/>
		</React.Fragment>
	);
};

export default FiscalYearList;
